var _g, _path, _g2, _g3, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProgramaDignidadeMenstrual = function SvgProgramaDignidadeMenstrual(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7502_1614)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "#FEECF1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1367 17.8518C14.5905 15.4195 14.704 14.8115 16.4437 15.3577C18.1833 15.9039 16.1205 19.0876 15.5955 20.6086C16.6085 20.4669 17.3142 21.2697 17.9617 21.8874C18.4768 22.3787 18.3445 22.7436 18.992 23.3613C19.5071 23.8528 19.2784 24.9881 18.992 25.8177C18.7057 26.6474 17.8014 24.1256 16.9315 23.8525C16.0617 23.5794 16.6194 23.2289 14.4448 22.5462C12.2702 21.8634 13.5695 20.8921 14.1367 17.8518L14.1367 17.8518Z",
    fill: "#FBC7D5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7502_1614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8057 13.1391C18.2709 12.3771 18.6372 10.5991 18.6372 9.8053C15.3405 10.1863 12.8679 10.4783 12.4101 15.2822L15.6152 15.7189C15.0197 14.678 14.7155 13.6978 15.0197 13.6722C15.5266 13.6295 16.1444 13.483 16.8057 13.1391Z",
    fill: "#FBC7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6156 15.4742C15.1044 15.1084 14.1626 13.8678 12.8676 14.609C10.5787 15.9194 13.7832 18.103 13.3256 21.1598C13.1328 22.4464 12.805 23.5459 12.4486 24.3834C12.0397 25.3444 11.9119 26.6939 12.7777 27.278C13.578 27.8178 14.7952 28.1047 17.3529 27.9645C20.6618 27.783 16.1413 21.7326 18.0863 19.4313C18.3916 18.849 18.7299 18.0791 17.5717 16.9742C17.0567 16.483 17.4469 16.7843 15.6156 15.4742ZM18.7074 9.3219C18.3276 8.02598 16.9916 6.45658 14.6996 7.18518C11.9524 8.05852 12.0609 9.56566 12.0609 10.4391C10.5156 9.94778 9.67847 12.5275 11.0306 13.3873C12.3826 14.2467 13.3197 13.3913 13.3197 12.0768C13.3197 11.1729 16.3888 10.639 18.1146 10.2291C18.5384 10.1285 18.8299 9.73985 18.7074 9.3219Z",
    fill: "#F65495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0764 17.852C12.5302 15.4198 12.6436 14.8117 14.3833 15.3579C16.123 15.9041 14.0601 19.0878 13.5351 20.6089C14.5481 20.4671 16.2841 21.761 16.9316 22.3787C17.4467 22.87 17.8295 22.7438 18.4769 23.3615C18.9921 23.853 19.2783 24.9882 18.992 25.8178C18.7057 26.6475 17.8014 24.1257 16.9315 23.8526C16.0617 23.5795 14.559 23.2292 12.3844 22.5464C10.2098 21.8637 11.5091 20.8923 12.0764 17.852Z",
    fill: "#FBC7D5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_7502_1614)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2094 14.1487C22.3151 14.002 22.5264 13.9531 22.6849 14.0509C22.7245 14.0753 22.7642 14.112 22.7906 14.1487C22.9755 14.4054 23.1736 14.6866 23.3981 14.9923C24.4415 16.4104 26 18.5377 26 19.7602C26 20.6527 25.6038 21.4596 24.9698 22.0464C24.3358 22.6332 23.4642 23 22.5 23C21.5358 23 20.6642 22.6332 20.0302 22.0586C19.3962 21.4718 19 20.6649 19 19.7724C19 18.5499 20.5585 16.4104 21.6019 14.9923C21.8396 14.6744 22.0377 14.4054 22.2094 14.1487ZM24.4998 19.5002C24.0003 19.5002 24.0003 19.9998 24.0003 19.9998C24.0003 20.5405 23.5622 21.0005 22.9998 21.0005C22.9998 21.0005 22.4998 21.003 22.4998 21.5014C22.4998 21.9998 22.9998 21.9998 22.9998 21.9998C24.1044 21.9998 24.9998 21.1044 24.9998 19.9998C24.9998 19.9998 24.9993 19.5002 24.4998 19.5002Z",
    fill: "#C8206F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7502_1614",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.691029 0 0 0 0 0.814999 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7502_1614"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7502_1614",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7502_1614",
    x: 9.35192,
    y: 6,
    width: 10.7536,
    height: 22.9998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.329412 0 0 0 0 0.584314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7502_1614"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7502_1614",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_7502_1614",
    x: 18,
    y: 13,
    width: 9,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.329412 0 0 0 0 0.584314 0 0 0 0.74 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7502_1614"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7502_1614",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProgramaDignidadeMenstrual, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/programa-dignidade-menstrual.3e9bf08e.svg";
export { ForwardRef as ReactComponent };